import React, { useState } from "react";
import "./UploadGSTINModal.css";
import { Trash2 } from "lucide-react";
import fileicon from "../../../assets/fileicon.png";
import IrnValidationModal from "../handleVerifyGSTINs/Verifygstin";
import { authenticatedFetch } from '../../../utils/api';


const UploadGSTINModal = ({ open, onClose }) => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [backgroundProcessMessage, setBackgroundProcessMessage] = useState("")
const [showBackgroundProcessModal, setShowBackgroundProcessModal] = useState(false);


  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setProgress(0);
      setUploadComplete(false);

      // Simulate upload progress
      const interval = setInterval(() => {
        setProgress((prev) => {
          const next = prev + 20;
          if (next >= 100) {
            clearInterval(interval);
            setUploadComplete(true);
            return 100;
          }
          return next;
        });
      }, 200);
    }
  };
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/assets/validated_invoices.csv'; 
    link.download = 'validated_invoices.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [isMissingColumnModalOpen, setIsMissingColumnModalOpen] = useState(false);
const [missingColumnMessage, setMissingColumnMessage] = useState("");

  


 const [verifygstinmodalOpen, setverifygstinModalOpen] = useState(false);
 const [irnData, setIrnData] = useState([]);

  const handleRemoveFile = () => {
    setFile(null);
    setProgress(0);
    setUploadComplete(false);
  };

  if (!open) return null;

  const handleVerifyGSTINs = async () => {
    if (!file || !uploadComplete) return;
  
    // Retrieve the user's email from local storage
    const userEmail = localStorage.getItem('email');
    if (!userEmail) {
      alert("Email not found in local storage.");
      return;
    }

     // Read and check file columns
  const requiredColumns = [
    "vendorGSTIN",
    "financialYear",
    "invoiceType",
    "invoiceNumber",
  ];

  const irnRequired = ["irnNumber"];

  const checkColumns = async () => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;
        const firstLine = text.split("\n")[0].trim();
        const headers = firstLine.split(",");

        const hasIRN = irnRequired.every((col) => headers.includes(col));
        const hasRequired = requiredColumns.every((col) =>
          headers.includes(col)
        );

        if (hasIRN || hasRequired) {
          resolve(true);
        } else {
          reject("Required columns are missing. Provide either 'irnNumber' or all of: " + requiredColumns.join(", "));
        }
      };

      reader.onerror = () => reject("Failed to read the file.");
      reader.readAsText(file);
    });
  };

  try {
    await checkColumns();
  } catch (err) {
    // alert(err);
    setMissingColumnMessage(err);
setIsMissingColumnModalOpen(true);
    return;
  }
  
    const handleBulkValidate = async (file) => {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('email', userEmail); // If you need to pass email

        const response = await authenticatedFetch("https://vendor-score.finkraftai.com/bulk-validate", {
          method: 'POST',
          body: formData,
          // Don't set Content-Type header when using FormData
          // The browser will set it automatically with the correct boundary
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        // Handle the response data
        return data;
      } catch (error) {
        console.error('Error during bulk validation:', error);
        throw error;
      }
    };
  
    setIsLoading(true);
  
    try {
      const data = await handleBulkValidate(file);
  
      if (data.message && data.message === "Data is being processed in the background. You will receive the results by email shortly.") {
        setBackgroundProcessMessage("Your data contains over 3,000 records,This may take a few moments. Once the processing is complete, the results will be sent to your email.");
        setShowBackgroundProcessModal(true);
      } else {
        const transformed = data.map(item => {
          const isSuccess = item.response?.status_cd === "1";
          const hasIrnInWebData = item.response?.web_data?.irn;
    
          // Fallback IRN logic
          const irn = item.irnNumber || null;
    
          return {
            irnNumber: irn,
            irpName: isSuccess ? item.response?.web_data?.regirp : null,
            status: isSuccess ? item.response?.web_data?.status : null,
            regtime: isSuccess ? item.response?.web_data?.regtime : null,
            irnInv: isSuccess ? item.response?.web_data?.irn : null,
            message: !isSuccess ? item.response?.message || "Unknown error" : null,
            financialYear: !irn ? item.financialYear || null : null,
            invoiceNumber: !irn ? item.invoiceNumber || null : null,
            invoiceType: !irn ? item.invoiceType || null : null,
            gstin: !irn ? item.vendorGSTIN : null,
            
          };
        });
    
        setIrnData(transformed);
        setverifygstinModalOpen(true);
      }
    } catch (error) {
      console.error("Error verifying GSTINs:", error);
      alert("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };
  
  
  

  return (
    <div className="modal-overlay">
      <IrnValidationModal
        isOpen={verifygstinmodalOpen}
        onClose={() => setverifygstinModalOpen(false)}
        irnData={irnData}
      />
      {isMissingColumnModalOpen && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h2 className="modal-title">Missing Required Columns</h2>
      <p className="modal-message">{missingColumnMessage}</p>
      <div className="modal-footer">
        <button
          className="modal-close-btn"
          onClick={() => setIsMissingColumnModalOpen(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

      {showBackgroundProcessModal && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  }}>
    <div style={{
      background: 'white',
      padding: '30px',
      borderRadius: '10px',
      textAlign: 'center',
      width: '400px'
    }}>
      <h2>Processing Request</h2>
      <p>{backgroundProcessMessage}</p>
      <button onClick={() => setShowBackgroundProcessModal(false)} style={{
        marginTop: '20px',
        padding: '10px 20px',
        borderRadius: '5px',
        background: '#007BFF',
        color: 'white',
        border: 'none'
      }}>
        OK
      </button>
    </div>
  </div>
)}



      <div className="modal">
      {isLoading && (
  <div className="loader-overlay">
    <div className="upload-loader">
      <span className="dot one"></span>
      <span className="dot two"></span>
      <span className="dot three"></span>
      <p>Uploading & Verifying GSTINs...</p>
    </div>
  </div>
)}
        <div className="modal-header">
            <div className="bulk-header-content">
            <div className="file-icon-div">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20.0625 10.5H13.5C12.9033 10.5 12.331 10.2629 11.909 9.84099C11.4871 9.41903 11.25 8.84674 11.25 8.25V1.6875C11.25 1.63777 11.2302 1.59008 11.1951 1.55492C11.1599 1.51975 11.1122 1.5 11.0625 1.5H6.75C5.95435 1.5 5.19129 1.81607 4.62868 2.37868C4.06607 2.94129 3.75 3.70435 3.75 4.5V19.5C3.75 20.2956 4.06607 21.0587 4.62868 21.6213C5.19129 22.1839 5.95435 22.5 6.75 22.5H17.25C18.0456 22.5 18.8087 22.1839 19.3713 21.6213C19.9339 21.0587 20.25 20.2956 20.25 19.5V10.6875C20.25 10.6378 20.2302 10.5901 20.1951 10.5549C20.1599 10.5198 20.1122 10.5 20.0625 10.5Z" fill="#222222"/>
            <path d="M19.6509 8.84062L12.9098 2.09953C12.8967 2.0865 12.8801 2.07763 12.8619 2.07405C12.8438 2.07046 12.825 2.07232 12.8079 2.07938C12.7908 2.08644 12.7762 2.0984 12.7659 2.11374C12.7556 2.12909 12.7501 2.14714 12.75 2.16562V8.25047C12.75 8.44938 12.829 8.64014 12.9697 8.7808C13.1103 8.92145 13.3011 9.00047 13.5 9.00047H19.5848C19.6033 9.00039 19.6214 8.99485 19.6367 8.98454C19.6521 8.97423 19.664 8.95962 19.6711 8.94254C19.6781 8.92546 19.68 8.90667 19.6764 8.88853C19.6728 8.8704 19.664 8.85373 19.6509 8.84062Z" fill="#222222"/>
            </svg>
        </div>
          <div style={{marginTop:'10px'}}>
            <h2>Upload GSTINs</h2>
          <p>Upload a CSV to import your GSTIN data.</p>
          </div>
            </div>
            <div onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
            <path d="M7.88477 20.6165L14.0016 14.4996L20.1184 20.6165M20.1184 8.38281L14.0004 14.4996L7.88477 8.38281" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </div>
        </div>
        <hr></hr>

        <div className="upload-box" onClick={() => document.getElementById("upload-input").click()}>
          
          <input
            type="file"
            accept=".csv"
            id="upload-input"
            className="hidden"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 4.5C16.6997 4.50012 16.8969 4.54512 17.0769 4.63166C17.2569 4.71821 17.4152 4.84408 17.54 5L22.8733 11.6667C22.9893 11.8025 23.0768 11.9602 23.1307 12.1305C23.1845 12.3008 23.2036 12.4802 23.1868 12.658C23.17 12.8358 23.1176 13.0084 23.0328 13.1656C22.948 13.3228 22.8325 13.4613 22.6931 13.573C22.5537 13.6847 22.3933 13.7672 22.2214 13.8157C22.0496 13.8642 21.8697 13.8777 21.6925 13.8553C21.5153 13.833 21.3444 13.7753 21.1899 13.6856C21.0355 13.5959 20.9006 13.4761 20.7933 13.3333L17.8333 9.63333V19.1667C17.8333 19.5203 17.6929 19.8594 17.4428 20.1095C17.1928 20.3595 16.8536 20.5 16.5 20.5C16.1464 20.5 15.8072 20.3595 15.5572 20.1095C15.3071 19.8594 15.1667 19.5203 15.1667 19.1667V9.63333L12.2067 13.3347C12.0994 13.4775 11.9645 13.5973 11.8101 13.6869C11.6556 13.7766 11.4847 13.8343 11.3075 13.8567C11.1303 13.879 10.9504 13.8656 10.7786 13.8171C10.6067 13.7685 10.4463 13.686 10.3069 13.5743C10.1675 13.4627 10.052 13.3241 9.96719 13.1669C9.88239 13.0097 9.83003 12.8371 9.81322 12.6593C9.79641 12.4815 9.81549 12.3021 9.86934 12.1318C9.92318 11.9616 10.0107 11.8038 10.1267 11.668L15.46 5.00133C15.5847 4.84517 15.7429 4.71904 15.9229 4.63226C16.1029 4.54549 16.3002 4.50028 16.5 4.5ZM12.5 19.1667V17.8333H7.16667C6.45942 17.8333 5.78115 18.1143 5.28105 18.6144C4.78095 19.1145 4.5 19.7928 4.5 20.5V25.8333C4.5 26.5406 4.78095 27.2189 5.28105 27.719C5.78115 28.219 6.45942 28.5 7.16667 28.5H25.8333C26.5406 28.5 27.2189 28.219 27.719 27.719C28.219 27.2189 28.5 26.5406 28.5 25.8333V20.5C28.5 19.7928 28.219 19.1145 27.719 18.6144C27.2189 18.1143 26.5406 17.8333 25.8333 17.8333H20.5V19.1667C20.5 20.2275 20.0786 21.2449 19.3284 21.9951C18.5783 22.7452 17.5609 23.1667 16.5 23.1667C15.4391 23.1667 14.4217 22.7452 13.6716 21.9951C12.9214 21.2449 12.5 20.2275 12.5 19.1667ZM23.1667 21.8333C22.813 21.8333 22.4739 21.9738 22.2239 22.2239C21.9738 22.4739 21.8333 22.813 21.8333 23.1667C21.8333 23.5203 21.9738 23.8594 22.2239 24.1095C22.4739 24.3595 22.813 24.5 23.1667 24.5H23.18C23.5336 24.5 23.8728 24.3595 24.1228 24.1095C24.3729 23.8594 24.5133 23.5203 24.5133 23.1667C24.5133 22.813 24.3729 22.4739 24.1228 22.2239C23.8728 21.9738 23.5336 21.8333 23.18 21.8333H23.1667Z" fill="#555555"/>
          </svg>
          <label htmlFor="upload-input" className="upload-label">
            Drag CSV here to import GSTINs
            <br />
            <span>or, click to browse (CSV only)</span>
          </label>
          <button className="uploadfile-btn">Upload File</button>
        </div>

        {file && (
      <div className="upload-card">
        <div className="file-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">
  <path d="M5.66732 19.3327H16.334V21.9993H5.66732V19.3327ZM5.66732 13.9993H16.334V16.666H5.66732V13.9993ZM13.6673 0.666016H3.00065C1.53398 0.666016 0.333984 1.86602 0.333984 3.33268V24.666C0.333984 26.1327 1.52065 27.3327 2.98732 27.3327H19.0007C20.4673 27.3327 21.6673 26.1327 21.6673 24.666V8.66602L13.6673 0.666016ZM19.0007 24.666H3.00065V3.33268H12.334V9.99935H19.0007V24.666Z" fill="#777777"/>
</svg>
        </div>
        <div className="file-details">
          <div className="file-header">
            <span className="file-name">{file.name}</span>
            <span className="file-size">
            {file.size < 1024
              ? `${file.size} Bytes`
              : `${(file.size / 1024).toFixed(0)} KB`}
          </span>
          </div>
          <div className="upload-status">
            {uploadComplete ? 'Upload Complete!' : 'Uploading...'}
          </div>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
        <div className="progress-text">{progress}%</div>
        <button className="remove-btn" onClick={handleRemoveFile}>
          <Trash2 size={18} color="#d22" />
        </button>
      </div>
    )}

        <div className="modal-footer">
        <button onClick={handleDownload} className="downloadfile">Download sample file</button>
          <button className="verify-btn" disabled={!uploadComplete} onClick={handleVerifyGSTINs}>
            Verify GSTINs
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadGSTINModal;